import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfJT",
  "use": "BankOfJT-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"BankOfJT\">\r\n<defs>\r\n    <style>\r\n      #BankOfJT .cls-1 {\r\n        fill: #1d2088;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfJT_交行logo\" class=\"cls-1\" d=\"M2708.74,788.441c-3.73,0-7.67.442-11.4,0.442-2.41,10.818-23.22,7.727-20.81-5.961,1.09-7.948,12.27-11.48,18.84-5.519a13.27,13.27,0,0,1,2.85,6.623c3.51,0,7.67-.442,11.18-0.442,0-17.441-19.51-26.272-33.97-17.883-14.24,7.948-12.49,32.9,2.41,38.857V805c-7.88,0-17.09-6.4-18.84-13.909V750.909c6.35-4.636,13.58-9.714,19.72-13.909a1.691,1.691,0,0,1,.66.441c-0.44,5.962,0,16.118.44,23.4,4.16-3.753,6.57-7.948,13.58-9.493a18.888,18.888,0,0,1,11.39.662c20.16,7.065,21.48,33.338,4.17,42.39a3.892,3.892,0,0,0-1.76,1.1,7.356,7.356,0,0,0,.66-1.324,25.785,25.785,0,0,0,.88-5.741h0Zm0,0\" transform=\"translate(-2656 -737)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfJT.svg
// module id = 8rQl
// module chunks = 37